import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	total: 0,
	page: 1,
	maxPage: 1,
	commissions: [],
};

const affiliateCommissionsSlice = createSlice({
	name: 'affiliateCommissions',
	initialState: initialState,
	reducers: {
		setAffiliateCommissions: (state, action) => action.payload,
		reset: (state, action) => initialState,
	},
});

export const { setAffiliateCommissions, reset } = affiliateCommissionsSlice.actions;

export default affiliateCommissionsSlice.reducer;